import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNDrug } from 'src/app/models/cndrug';
import { CNDrugPackage } from 'src/app/models/cndrugpackage';
import { CNPrescription } from 'src/app/models/cnprescription';
import { CNPrescriptionEntry } from 'src/app/models/cnprescriptionentry';
import { PrescriptionUiService } from 'src/app/services/prescription-ui.service';
import { PrescriptionService } from 'src/app/services/prescription.service';
import { TypeManagerService } from 'src/app/services/type-manager.service';
import { SNItemTableService } from 'src/app/snitem-table/snitem-table-interface';

@ManageType('PrescriptionDialogComponent')
@Component({
  selector: 'app-prescription-dialog',
  templateUrl: './prescription-dialog.component.html',
  styleUrls: ['./prescription-dialog.component.scss']
})
export class PrescriptionDialogComponent implements OnInit {

  public prescription: CNPrescription;

  constructor(private typeManager: TypeManagerService, private dialog: MatDialog,
              private dialogRef: MatDialogRef<PrescriptionDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, private prescriptions: PrescriptionService) {
                if (data && data.prescription) {
                  this.prescription = data.prescription;
                }
              }

  ngOnInit(): void {
  }

  selectDrugPackage(drugpackage: [CNDrug, CNDrugPackage]) {
    // From drug add a prescription
    const fields = {
      type: 'medication',
      drugindex: -1,
      itemid: 0,
      drugid: drugpackage[0].id,
      packageid: drugpackage[1].id,
      druglabel: drugpackage[0].getProperty('fr'),
//      drug,
//      drugpackage: this.item,
      packagelabel: drugpackage[1].getProperty('fr'),
      StartDate: new Date(),
      EndDate: '',
      healthagentaccess: '',
      careteamaccess: '',
      Comment: '',
      poso1: '',
      poso2: '',
      poso3: '',
      poso4: '',
      poso5: '',
      poso6: '',
      poso7: '',
      poso8: '',
      poso9: '',
      poso10: '',
      poso11: '',
      poso12: '',
      addtotreatment: true,
      weeks: '',
      days: '',
      perday: 1,
      packagenb: 1,
      showposo: false,
      risk: false,
      chronic: false,
      classification: '',
      code: ''
    };
    const fieldKeys = Object.keys(fields);
    const entry = new CNPrescriptionEntry();
    entry.value = drugpackage[1].getProperty('fr');
    fieldKeys.forEach(aKey => {
      entry.setProperty(aKey, fields[aKey]);
    });
    console.log('adding entry', entry);
    this.prescription.addChild(entry, false).subscribe();
  }

  close() {
    // Remove all added entry with id = 0
    this.prescription.purgeChilds$('SNItem.CNItem.CNPrescriptionEntry');
    this.dialogRef.close();
  }

  save() {
    // Create or update prescription
    this.prescriptions.updatePrescription(this.prescription).subscribe(updatedPrescription => {
      this.dialogRef.close(updatedPrescription);
    });
  }

  addDrug() {
    // Open drug dialog
    if (this.typeManager.typeMap('DrugDialogComponent')) {
      const componentFactory = this.typeManager.typeMap('DrugDialogComponent');
      const dialogRef = this.dialog.open(componentFactory);
      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }

  addComment() {
    // Open comment dialog
    if (this.typeManager.typeMap('CommentDialogComponent')) {
      const componentFactory = this.typeManager.typeMap('CommentDialogComponent');
      const dialogRef = this.dialog.open(componentFactory);
      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }

  store() {
    // Store current prescription
    // if (this.prescriptions.) {
    //   this.service.store();
    // }
  }

  sendEHealth() {
    // this.service.send();
  }
}
